import { createStructuredSelector } from "reselect";
import {
    HL_SUPPLIER,
    HL_SUPPLIER_SUCCESS,
    HL_SUPPLIER_ERROR,
    HL_CATEGORY,
    HL_CATEGORY_SUCCESS,
    HL_CATEGORY_ERROR,
    HL_LIST,
    HL_LIST_SUCCESS,
    HL_LIST_ERROR,
    HL_LIST_SEARCH_CHANGE,
    HL_LIST_PAGE_SET,
    HL_ADD_MODAL_SET,
    HL_ADD_CHANGE_SET,
    HL_ADD,
    HL_ADD_SUCCESS,
    HL_ADD_ERROR,
    HL_EDIT_MODAL_SET,
    HL_EDIT_CHANGE_SET,
    HL_EDIT,
    HL_EDIT_SUCCESS,
    HL_EDIT_ERROR,
    HL_UPLOAD_SET,
    HL_UPLOAD_SET_SUCCESS,
    HL_UPLOAD_SET_ERROR,
    HL_UPLOAD_RESET
} from "../../actions";

export const NAME = 'healthLicense';

export const HLSupplier = (data) => ({
    type: HL_SUPPLIER,
    payload: data
});

export const HLSupplierSuccess = (data) => ({
    type: HL_SUPPLIER_SUCCESS,
    payload: data
});

export const HLSupplierError = (error) => ({
    type: HL_SUPPLIER_ERROR,
    payload: error
});

export const HLCategory = (data) => ({
    type: HL_CATEGORY,
    payload: data
});

export const HLCategorySuccess = (data) => ({
    type: HL_CATEGORY_SUCCESS,
    payload: data
});

export const HLCategoryError = (error) => ({
    type: HL_CATEGORY_ERROR,
    payload: error
});

export const HLList = (page, num_page, orderBy, filters, stateFilter) => ({
    type: HL_LIST,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter }
});

export const HLListSuccess = (data) => ({
    type: HL_LIST_SUCCESS,
    payload: data
});

export const HLListError = (error) => ({
    type: HL_LIST_ERROR,
    payload: error
});

export const HLPageSet = (data) => ({
    type: HL_LIST_PAGE_SET,
    payload: data
});

export const HLSearchChange = (data) => ({
    type: HL_LIST_SEARCH_CHANGE,
    payload: data
});

export const HLAddModalSet = (data) => ({
    type: HL_ADD_MODAL_SET,
    payload: data
});

export const HLAddChangeSet = (data) => ({
    type: HL_ADD_CHANGE_SET,
    payload: data
});

export const HLAdd = (page, num_page, orderBy, filters, data) => ({
    type: HL_ADD,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const HLAddSuccess = (message) => ({
    type: HL_ADD_SUCCESS,
    payload: message
});

export const HLAddError = (error) => ({
    type: HL_ADD_ERROR,
    payload: error
});


export const HLEditModalSet = (data) => ({
    type: HL_EDIT_MODAL_SET,
    payload: data
});

export const HLEditChangeSet = (data) => ({
    type: HL_EDIT_CHANGE_SET,
    payload: data
});

export const HLEdit = (page, num_page, orderBy, filters, data) => ({
    type: HL_EDIT,
    payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, data: data }
});

export const HLEditSuccess = (message) => ({
    type: HL_EDIT_SUCCESS,
    payload: message
});

export const HLEditError = (error) => ({
    type: HL_EDIT_ERROR,
    payload: error
});

export const HLUploadSet = (file) => ({
    type: HL_UPLOAD_SET,
    payload: { file },
});

export const HLUploadSetSuccess = (items) => ({
    type: HL_UPLOAD_SET_SUCCESS,
    payload: items,
});

export const HLUploadSetError = (error) => ({
    type: HL_UPLOAD_SET_ERROR,
    payload: error,
});

export const HLUploadReset = () => ({
    type: HL_UPLOAD_RESET
});

const healthLicense = (state) => state[NAME];

export const HealthLicenseSelector = createStructuredSelector({
    healthLicense
})